export const pt_BR = {
  translation: {
    post: "publicação",
    remove_post: "Apagar publicação",
    no_posts: "Sem publicações.",
    create_a_post: "Fazer uma publicação",
    create_post: "Fazer uma publicação",
    number_of_posts_0: "{{formattedCount}} publicação",
    number_of_posts_1: "{{formattedCount}} publicações",
    number_of_posts_2: "{{formattedCount}} publicações",
    posts: "Publicações",
    related_posts: "Essas publicações podem estar relacionadas",
    cross_posts: "Esse link também foi publicado em:",
    cross_post: "Republicar",
    cross_posted_to: "Publicado também em: ",
    comments: "Comentários",
    number_of_comments_0: "{{formattedCount}} comentário",
    number_of_comments_1: "{{formattedCount}} comentários",
    number_of_comments_2: "{{formattedCount}} comentários",
    remove_comment: "Apagar comentário",
    communities: "Comunidades",
    users: "Usuários",
    create_a_community: "Criar uma comunidade",
    create_community: "Criar comunidade",
    remove_community: "Apagar comunidade",
    subscribed_to_communities: "Participando das <1>comunidades</1>",
    trending_communities: "<1>Comunidades</1> em tendência",
    list_of_communities: "Lista de comunidades",
    number_of_communities_0: "{{formattedCount}} comunidade",
    number_of_communities_1: "{{formattedCount}} comunidades",
    number_of_communities_2: "{{formattedCount}} comunidades",
    community_reqs: "minúsculas, sublinhados e sem espaços.",
    create_private_message: "Criar mensagem privada",
    send_secure_message: "Enviar mensagem segura",
    send_message: "Enviar mensagem",
    message: "Mensagem",
    edit: "editar",
    reply: "Responder",
    cancel: "Cancelar",
    preview: "Pré-visualização",
    upload_image: "fazer upload de imagem",
    avatar: "Avatar",
    upload_avatar: "Fazer upload de avatar",
    show_avatars: "Mostrar avatares",
    formatting_help: "ajuda de formatação",
    view_source: "Ver fonte",
    unlock: "Desbloquear",
    lock: "Bloquear",
    sticky: "fixar",
    unsticky: "desafixar",
    link: "Link",
    archive_link: "arquivar link",
    mod: "mod",
    mods: "mods",
    moderates: "Modera",
    settings: "Configurações",
    remove_as_mod: "Apagar como mod",
    appoint_as_mod: "Designar a moderação",
    modlog: "Relatório de moderação",
    admin: "admin",
    admins: "admins",
    remove_as_admin: "Apagar como admin",
    appoint_as_admin: "Designar a administração",
    remove: "Apagar",
    removed: "Apagado pela moderação",
    locked: "Trancado",
    stickied: "fixado",
    reason: "Motivo",
    mark_as_read: "Marcar como lido",
    mark_as_unread: "Marcar como não lido",
    delete: "Apagar",
    deleted: "apagado por quem criou",
    delete_account: "Apagar conta",
    delete_account_confirm: "Aviso: isso excluirá permanentemente a sua conta. A exclusão pode não se propagar por outras instâncias. Digite sua senha para confirmar.",
    restore: "Restaurar",
    ban: "Banir",
    ban_from_site: "Banir do site",
    unban: "Desbanir",
    unban_from_site: "Desbanir do site",
    banned: "Baniram",
    save: "Guardar",
    unsave: "Não guardar",
    create: "Criar",
    creator: "autoria",
    username: "Nome da Conta",
    email_or_username: "E-mail ou nome de usuário",
    number_of_users_0: "{{formattedCount}} usuário",
    number_of_users_1: "{{formattedCount}} usuários",
    number_of_users_2: "{{formattedCount}} usuários",
    number_of_subscribers_0: "{{formattedCount}} participante",
    number_of_subscribers_1: "{{formattedCount}} participantes",
    number_of_subscribers_2: "{{formattedCount}} participantes",
    number_of_points_0: "{{formattedCount}} ponto",
    number_of_points_1: "{{formattedCount}} pontos",
    number_of_points_2: "{{formattedCount}} pontos",
    name: "Nome",
    title: "Título",
    subscribers: "Participantes",
    both: "Ambos",
    saved: "Guardado",
    unsubscribe: "Deixar de Participar",
    subscribe: "Participar",
    subscribed: "Participando",
    prev: "Anterior",
    next: "Próximo",
    sidebar: "Barra lateral",
    sort_type: "Ordenação",
    hot: "Em alta",
    new: "Novo",
    old: "Velho",
    month: "Mês",
    all: "Tudo",
    top: "Top",
    api: "API",
    docs: "Documentação",
    inbox: "Caixa de entrada",
    inbox_for: "Caixa de entrada de <1>{{user}}</1>",
    mark_all_as_read: "marcar tudo como lido",
    type: "Tipo",
    unread: "Não lido",
    replies: "Respostas",
    mentions: "Menções",
    reply_sent: "Resposta enviada",
    message_sent: "Mensagem enviada",
    search: "Pesquisar",
    overview: "Visão geral",
    view: "Visualização",
    logout: "Sair",
    login_sign_up: "Entrar / Inscrever-se",
    login: "Entrar",
    sign_up: "Inscrever-se",
    notifications_error: "Seu navegador não oferece notificações para a área de trabalho. Tente o Firefox ou o Chrome.",
    unread_messages_0: "{{formattedCount}} Mensagem não lida",
    unread_messages_1: "{{formattedCount}} Mensagens não lidas",
    unread_messages_2: "{{formattedCount}} Mensagens não lidas",
    messages: "Mensagens",
    password: "Senha",
    verify_password: "Verifique a senha",
    old_password: "Senha antiga",
    forgot_password: "Esqueci a senha",
    reset_password_mail_sent: "Enviado um e-mail para a alteração da senha.",
    password_change: "Alteração de senha",
    new_password: "Nova senha",
    no_email_setup: "Esse servidor não configurou corretamente o e-mail.",
    email: "E-mail",
    matrix_user_id: "Usuário Matrix",
    private_message_disclaimer: "Aviso: mensagens privadas no Lemmy não são seguras. Crie uma conta no <1>Matrix</1> para troca segura de mensagens.",
    send_notifications_to_email: "Enviar notificações para o e-mail",
    optional: "Opcional",
    expires: "Expira",
    language_0: "Idioma",
    language_1: "Idiomas",
    language_2: "Idiomas",
    downvotes_disabled: "Votos negativos desativados",
    enable_downvotes: "Permitir votos negativos",
    open_registration: "Permitir registro",
    registration_closed: "Registros desativados",
    enable_nsfw: "Permitir NSFW",
    url: "URL",
    body: "Conteúdo",
    copy_suggested_title: "copiar título sugerido: {{title}}",
    community: "Comunidade",
    expand_here: "Expandir aqui",
    subscribe_to_communities: "Participe de algumas <1>comunidades</1>.",
    chat: "Chat",
    recent_comments: "Últimos comentários",
    no_results: "Nenhum resultado.",
    setup: "Instalação",
    lemmy_instance_setup: "Criação de instância Lemmy",
    setup_admin: "Configurar administrador do site",
    modified: "modificado",
    nsfw: "NSFW",
    show_nsfw: "Mostrar conteúdo NSFW",
    theme: "Tema",
    code: "Code",
    joined: "Participando",
    by: "por",
    to: "para",
    from: "de",
    transfer_community: "Transferir comunidade",
    transfer_site: "Transferir site",
    are_you_sure: "tem certeza?",
    yes: "Sim",
    no: "Não",
    not_logged_in: "Fora de sessão.",
    logged_in: "Iniciou a sessão.",
    community_ban: "Te baniram dessa comunidade.",
    site_ban: "Te baniram do site",
    couldnt_create_comment: "Não foi possível criar o comentário.",
    couldnt_like_comment: "Não foi possível curtir o comentário.",
    couldnt_update_comment: "Não foi possível atualizar o comentário.",
    couldnt_save_comment: "Não foi possível salvar o comentário.",
    no_comment_edit_allowed: "Sem permissão para editar comentário.",
    no_post_edit_allowed: "Sem permissão para editar publicação.",
    no_community_edit_allowed: "Sem permissão para editar comunidade.",
    couldnt_find_community: "Não foi possível encontrar a comunidade.",
    couldnt_update_community: "Não foi possível atualizar a comunidade.",
    community_already_exists: "Esta comunidade já existe.",
    community_moderator_already_exists: "Essa pessoa já modera esta comunidade.",
    community_follower_already_exists: "Essa pessoa já segue a comunidade.",
    community_user_already_banned: "Essa pessoa já foi banida da comunidade.",
    couldnt_create_post: "Não foi possível fazer a publicação.",
    couldnt_like_post: "Não foi possível curtir a publicação.",
    couldnt_find_post: "Não foi possível encontrar a publicação.",
    couldnt_get_posts: "Não foi possível obter as publicações",
    couldnt_update_post: "Não foi possível atualizar a publicação",
    couldnt_save_post: "Não foi possível guardar a publicação.",
    no_slurs: "Sem insultos.",
    not_an_admin: "Não é Admin.",
    site_already_exists: "O site já existe.",
    couldnt_update_site: "Não foi possível atualizar o site.",
    couldnt_find_that_username_or_email: "Não foi possível encontrar esse nome ou e-mail.",
    password_incorrect: "Senha incorreta.",
    passwords_dont_match: "As senhas não são iguais.",
    admin_already_created: "Desculpe, já há alguém que é Admin.",
    user_already_exists: "Esse nome já está em uso.",
    email_already_exists: "Esse e-mail já foi usado.",
    couldnt_update_user: "Não foi possível atualizar a conta.",
    system_err_login: "Erro no sistema. Tente sair e autenticar-se outra vez.",
    couldnt_create_private_message: "Não foi possível criar mensagem privada.",
    no_private_message_edit_allowed: "Sem permissão para editar mensagem privada.",
    couldnt_update_private_message: "Não foi possível atualizar a mensagem privada.",
    time: "Tempo",
    action: "Ação",
    more: "Mais",
    couldnt_get_comments: "Não foi possível obter os comentários.",
    upvote: "Voto positivo",
    downvote: "Voto negativo",
    block_leaving: "Tem certeza que quer sair?",
    sorting_help: "ajuda com a ordenação",
    number_of_upvotes_0: "{{formattedCount}} voto positivo",
    number_of_upvotes_1: "{{formattedCount}} votos positivos",
    number_of_upvotes_2: "{{formattedCount}} votos positivos",
    number_of_downvotes_0: "{{formattedCount}} voto negativo",
    number_of_downvotes_1: "{{formattedCount}} votos negativos",
    number_of_downvotes_2: "{{formattedCount}} votos negativos",
    show_context: "Mostrar contexto",
    invalid_community_name: "Nome inválido.",
    click_to_delete_picture: "Clique para deletar imagem: {{filename}}",
    picture_deleted: "Imagem removida: {{filename}}",
    admin_settings: "Configurações de Admin",
    site_config: "Configuração do site",
    banned_users: "Usuários banidos",
    site_saved: "Site salvo.",
    emoji_picker: "Selecionador de emoji",
    select_a_community: "Selecione uma comunidade",
    invalid_username: "Nome da Conta inválido.",
    must_login: "Você precisa <1>entrar</1> ou <2>registrar-se</2> para comentar.",
    no_password_reset: "Você não conseguirá redefinir sua senha sem um e-mail.",
    invalid_post_title: "Título de publicação inválido",
    cake_day_info: "Hoje é o dia do bolo de {{creator_name}}!",
    cake_day_title: "Dia do bolo:",
    what_is: "Quanto é",
    invalid_password: "A senha deve ter entre 10 a 60 caracteres.",
    play_captcha_audio: "Tocar o áudio do Captcha",
    bio: "Biografia",
    instances: "Instâncias",
    linked_instances: "Instâncias ligadas",
    quote: "citação",
    spoiler: "spoiler",
    list: "Lista",
    bold: "negrito",
    italic: "itálico",
    subscript: "subscrito",
    superscript: "sobrescrito",
    header: "cabeçalho",
    strikethrough: "riscado",
    not_a_moderator: "Não é Mod.",
    invalid_url: "URL inválida.",
    local: "Local",
    none_found: "Nenhum encontrado.",
    banner: "Banner",
    icon: "Ícone",
    upload_icon: "Fazer upload de um ícone",
    upload_banner: "Fazer upload de um banner",
    leave_mod_team: "Sair da equipe de moderação",
    name_explain: "Nome – usado como o identificador da comunidade, não pode ser alterado.",
    display_name: "Nome de exibição",
    display_name_explain: "Nome de exibição – título da página da comunidade, pode ser alterado.",
    active: "Ativo",
    bio_length_overflow: "A biografia não pode ter mais de 1000 caracteres.",
    captcha_incorrect: "Captcha incorreto.",
    enter_code: "Digite o código",
    not_a_mod_or_admin: "Não é Mod ou Admin.",
    new_comments: "Novos comentários",
    allowed_instances: "Instâncias permitidas",
    blocked_instances: "Instâncias bloqueadas",
    expand: "Expandir",
    collapse: "Encolher",
    captcha: "Captcha",
    most_comments: "Mais comentados",
    day: "Dia",
    week: "Semana",
    number_of_months_0: "{{formattedCount}} mês",
    number_of_months_1: "{{formattedCount}} meses",
    number_of_months_2: "{{formattedCount}} meses",
    join_lemmy: "Junte-se ao Lemmy",
    support_lemmy: "Apoie o Lemmy",
    weak: "Fraca",
    medium: "Média",
    strong: "Forte",
    local_description: "Mostra apenas as comunidades locais",
    remove_content_more: "Apagar publicações, comentários e comunidades",
    active_users_in_the_last_six_months_0: "{{formattedCount}} usuário ativo nos últimos 6 meses",
    active_users_in_the_last_six_months_1: "{{formattedCount}} usuários ativos nos últimos 6 meses",
    active_users_in_the_last_six_months_2: "{{formattedCount}} usuários ativos nos últimos 6 meses",
    all_description: "Mostre todas as comunidades, incluindo as federadas",
    websocket_disconnected: "Websocket desconectado",
    websocket_reconnected: "Websocket reconectado",
    remove_content: "Apagar conteúdo",
    show_read_posts: "Mostrar publicações lidas",
    comment_here: "Digite aqui para comentar...",
    explore_communities: "Explore comunidades",
    trending: "Em Alta",
    profile: "Perfil",
    only_admins_can_create_communities: "Somente a administração pode criar comunidades",
    show_scores: "Mostrar pontuações",
    bot_account: "Conta de bot",
    show_bot_accounts: "Mostrar contas de bots",
    subscribed_description: "Mostra as comunidades que você participa",
    description: "Descrição",
    very_weak: "Muito fraca",
    unread_reports_0: "{{formattedCount}} Denúncia não lida",
    unread_reports_1: "{{formattedCount}} Denúncias não lidas",
    unread_reports_2: "{{formattedCount}} Denúncias não lidas",
    created: "criado",
    couldnt_mark_post_as_read: "Não foi possível marcar publicação como lida.",
    couldnt_find_parent_comment: "Não foi possível encontrar o comentário de origem.",
    parent_comment_not_in_post: "O comentário de origem pertence a outra publicação.",
    site_description_length_overflow: "Descrição do site não pode exceder 150 caracteres.",
    blocked_users: "Pessoas bloqueadas",
    block_user: "Bloquear usuário",
    blocked_communities: "Comunidades bloqueadas",
    blocked: "Bloqueou",
    unblocked: "Desbloqueou",
    unblock_user: "Desbloquear usuário",
    block_community: "Bloquear comunidade",
    unblock_community: "Desbloquear comunidade",
    blocks: "Bloqueios",
    person_block: "Essa pessoa te bloqueou.",
    report_reason_required: "Motivo da denúncia é necessário.",
    couldnt_resolve_report: "Não foi possível resolver a denúncia.",
    unresolved_by: "Reaberto por <1></1>",
    show_report_dialog: "Mostrar painel de denúncia",
    create_report: "Criar denúncia",
    resolve_report: "Resolver denúncia",
    unresolve_report: "Reabrir denúncia",
    report_created: "Denúncia feita.",
    active_users_in_the_last_day_0: "{{formattedCount}} usuário ativo no último dia",
    active_users_in_the_last_day_1: "{{formattedCount}} usuários ativos no último dia",
    active_users_in_the_last_day_2: "{{formattedCount}} usuários ativos no último dia",
    active_users_in_the_last_week_0: "{{formattedCount}} usuário ativo na última semana",
    active_users_in_the_last_week_1: "{{formattedCount}} usuários ativos na última semana",
    active_users_in_the_last_week_2: "{{formattedCount}} usuários ativos na última semana",
    active_users_in_the_last_month_0: "{{formattedCount}} usuário ativo no último mês",
    active_users_in_the_last_month_1: "{{formattedCount}} usuários ativos no último mês",
    active_users_in_the_last_month_2: "{{formattedCount}} usuários ativos no último mês",
    change_password: "Mudar a senha",
    password_changed: "Senha mudada.",
    invalid_matrix_id: "Id de Matrix inválido. Deve ser @usuário:instância.tld",
    community_creation_admin_only: "Somente a administração pode criar comunidades",
    report_too_long: "Denúncia longa demais.",
    couldnt_create_report: "Não foi possível criar a denúncia.",
    reports: "Denúncias",
    reporter: "Denunciante",
    resolved_by: "Resolvido por <1></1>",
    couldnt_find_comment: "Não foi possível encontrar o comentário.",
    fill_out_application: "Para se juntar a esse servidor você precisa preencher essa solicitação e esperar ser aprovada.",
    application_questionnaire: "Questionário de solicitação",
    registration_application_answer_required: "É exigida solicitação de registro.",
    unread_registration_applications_0: "{{formattedCount}} Solicitação não lida",
    unread_registration_applications_1: "{{formattedCount}} Solicitações não lidas",
    unread_registration_applications_2: "{{formattedCount}} Solicitações não lidas",
    require_email_verification: "Exigir verificação de e-mail",
    number_of_days: "Número de dias",
    required: "Necessário",
    verify_email: "Verificar e-mail",
    verify_email_sent: "E-mail de verificação enviado.",
    registration_application_sent: "Solicitação de registro enviada.",
    private_instance: "Instância privada",
    registration_application_pending: "Aprovação de registro pendente.",
    registration_denied: "Solicitação de registro recusada.",
    email_not_verified: "E-mail não verificado.",
    email_required: "É exigido e-mail.",
    instance_is_private: "Essa instância é privada.",
    apply_to_join: "Solicite sua inscrição",
    registration_applications: "Solicitações de registro",
    applicant: "Solicitante",
    deny_reason: "Motivo da recusa",
    approved_by: "Aprovada por <1></1>",
    denied_by: "Recusada por <1></1>",
    approve: "Aprovar",
    deny: "Recusar",
    require_registration_application: "Exigir solicitação de registro",
    email_verified: "O seu e-mail foi verificado.",
    answer: "Responder",
    cannot_leave_admin: "Você não pode deixar o servidor sem Admin",
    default_theme: "Tema padrão",
    leave_admin_team: "Deixar a equipe de administração",
    left_admin_team: "Você saiu da equipe de administração",
    slur_filter_regex: "Expressões Regulares (regex) do filtro de insultos",
    federation_enabled: "Federação ativada",
    federation_debug: "Modo debug de federação",
    federation_strict_allowlist: "Lista branca da federação estrita",
    easy: "Fácil",
    hard: "Difícil",
    rate_limit_message: "Mensagem",
    rate_limit_post: "Publicação",
    rate_limit_register: "Registro",
    rate_limit_image: "Imagem",
    rate_limit_comment: "Comentário",
    rate_limit_search: "Pesquisa",
    per_second: "Por segundo",
    x_more_replies_0: "mais {{formattedCount}} resposta",
    x_more_replies_1: "mais {{formattedCount}} respostas",
    x_more_replies_2: "mais {{formattedCount}} respostas",
    too_many_images_upload_0: "O limite de {{formattedCount}} imagem para upload foi ultrapassado. Selecione apenas uma imagem, por favor.",
    too_many_images_upload_1: "O limite de {{formattedCount}} imagens para upload foi ultrapassado. Selecione menos imagens, por favor.",
    too_many_images_upload_2: "O limite de {{formattedCount}} imagens para upload foi ultrapassado. Selecione menos imagens, por favor.",
    application_email_admins: "Enviar e-mail para Admins ao receber novas solicitações",
    view_all_comments: "Ver todos os comentários",
    undistinguish: "Falar como usuário",
    filter_by_user: "Filtrar por usuário",
    distinguish: "Falar como mod",
    filter_by_action: "Filtrar por ação",
    filter_by_mod: "Filtrar por mod",
    only_mods_can_post_in_community: "Somente a moderação pode publicar nessa comunidade",
    failed_to_delete_picture: "Falha ao deletar imagem: {{filename}}",
    purge_user: "Expurgar usuário",
    purge: "Expurgar",
    purge_post: "Expurgar publicação",
    purge_comment: "Expurgar comentário",
    purge_community: "Expurgar comunidade",
    purge_warning: "Aviso: Expurgar vai deletar esse item e todos os descendentes da base de dados. É impossível recuperar os dados perdidos. Utilize com extremo cuidado.",
    purge_success: "O item foi expurgado com sucesso.",
    subscribe_pending: "Inscrição pendente",
    listing_type: "Tipo de listagem",
    interface_language: "Linguagem da interface",
    legal_information: "Legal",
    hide_modlog_mod_names: "Ocultar nome de Mods no relatório de moderação",
    rate_limit_error: "Número de requisições muito alto, tente novamente mais tarde.",
    custom_emoji_save_validation: "Todos os campos devem ser preenchidos, não pode haver shortcodes iguais.",
    featured: "Em destaque",
    taglines: "Etiquetas",
    add_tagline: "Adicionar etiqueta",
    feature_in_local: "Destacar em local",
    unfeature_from_local: "Retirar destaque em Local",
    feature_in_community: "Destacar na comunidade",
    unfeature_from_community: "Retirar destaque na comunidade",
    deleted_emoji: "Emoji removido",
    saved_emoji: "Emoji salvo",
    add_custom_emoji: "Adicionar emoji customizado",
    column_keywords: "Palavras-chave (separadas por espaço)",
    column_imageurl: "URL da imagem",
    column_shortcode: "Código curto",
    column_category: "Categoria",
    column_emoji: "Emoji",
    custom_emojis: "Emojis customizados",
    emojis: "Emojis",
    emoji: "Emoji",
    site: "Site",
    ban_from_community: "Banir da comunidade",
    undetermined_language_warning: "Aviso: Se ‘undetermined’ não estiver também selecionado, você não verá a maior parte dos conteúdos.",
    reports_email_admins: "Enviar e-mail para Admins ao receber novas denúncias",
    profile_not_logged_in_alert: "Você não se logou. Se você usa uma conta no Fediverso que lhe permite seguir perfis, você pode seguir este.",
    community_not_logged_in_alert: "Você não se logou. Mas você pode participar a partir de outra conta no Fediverso, como Lemmy ou Mastodon. Para isso, copie e cole no campo de busca da usa instância o seguinte: <1>!{{community}}@{{instance}}</1>",
    loading: "Carregando",
    modlog_content_warning: "<1>AVISO DE CONTEÚDO</1>: Algumas publicações removidas podem conter conteúdo perturbador ou para maiores de idade. Prossiga com cuidado.",
    error_page_title: "Erro!",
    error_page_paragraph: "Houve um erro no servidor. Tente recarregar a página. Se isto não funcionar, volte mais tarde. Se o problema persistir, você pode procurar por ajuda na <1>comunidade de suporte do Lemmy</1> ou na <2>sala do Lemmy no Matrix</2>.",
    error_page_admin_matrix: "Se você quiser entrar em contato com alguém da administração de {{instance}} para suporte, tente o seguinte endereço do Matrix:",
    error_code_message: "O servidor retornou esse erro: <1>{{error}}</1>. Isto pode ser útil para admins e developers para diagnosticar e consertar o erro",
    not_found_page_title: "Página não encontrada",
    not_found_page_message: "A página que você procura não existe.",
    not_found_return_home_button: "Clique aqui para voltar à usa página inicial",
    language_select_placeholder: "Selecione língua",
    software: "Software",
    version: "Versão",
    federation_http_fetch_retry_limit: "Limite de tentativas para pedidos HTTP de federação",
    column_alttext: "Texto alternativo",
    federation_worker_count: "Número de processos de federação (\"workers\")",
    show_password: "Exibir senha",
    hide_password: "Ocultar senha",
    rate_limit_header: "Opções de limite de frequência",
    upload_too_large: "A imagem enviada é grande demais!",
    moderator_view: "Visualização de Moderador",
    moderator_view_description: "Mostrar apenas contribuições de comunidades das quais você seja moderador",
    registration_mode: "Modo de inscrição",
    application_email_reason_none: "Solicitação negada",
    invalid_regex: "Expressão regular inválida.",
    permissive_regex: "A expressão regular iria aceitar qualquer texto informado.",
    rate_limit: "Limite de frequência",
    featured_in_local: "Em destaque em local",
    jump_to_content: "Ir direto ao conteúdo",
    cant_enable_private_instance_and_federation_together: "Não é possível habilitar instância privada e federação simultaneamente",
    remove_instance: "Remover instância",
    add_instance: "Adicionar instância",
    open_links_in_new_tab: "Abrir links em uma nova aba",
    couldnt_create_audio_captcha: "Não foi possível criar CAPTCHA sonoro.",
    incorrect_login: "Credenciais de entrada incorretos",
    site_name_required: "Nome do site é necessário.",
    site_name_length_overflow: "Nome do site não pode exceder 20 caracteres",
    reset_password: "Redefinir senha",
    featured_in_community: "Em destaque na comunidade",
    op: "OP",
    fetch_community: "Buscar comunidade",
    controversial: "Controverso",
    remote_follow: "Seguir remotamente",
    remote_follow_modal_title: "Inscrever-se a partir de uma instância remota",
    community_federated: "Comunidade federada!",
    fetching_community: "Buscando {{community}}",
    could_not_fetch_community: "Não se pode buscar {{community}}",
    close_registration: "Inscrição fechada",
    actor_name_max_length: "Comprimento máximo para nomes de intervenientes (\"actors\")",
    remote_follow_prompt: "Insira a instância da qual você gostaria de seguir esta comunidade",
    blur_nsfw: "Borrar conteúdo adulto",
    block_instance: "Bloquear instância",
    unblock_instance: "Desbloquear instância",
    submit: "Enviar",
    pictures_uploaded_progess: "{{uploaded}}/{{total}} imagens subidas",
    community_locked: "Comunidade trancada",
    distinguished_comment: "Comentário como moderador",
    remove_as_mod_are_you_sure: "Tem certeza que deseja remover {{user}} como moderador da {{community}}?",
    appointed_admin: "Designado como admin",
    appoint_as_mod_are_you_sure: "Tem certeza que deseja designar {{user}} como mod da {{community}}?",
    appoint_as_admin_are_you_sure: "Tem certeza que deseja designar {{user}} como admin de {{instance}}?",
    banning: "Banindo {{user}}",
    unban_from_community_with_name: "Desbanir {{user}} de {{community}}",
    import_success: "Configurações exportadas com sucesso!",
    community_locked_message: "<1>Comunidade trancada:</1> somente moderadores podem criar publicações. Você ainda pode comentar nas publicações.",
    scaled: "Escalonado",
    import_export_section_title: "Importar/Exportar configurações",
    export_error: "Erro ao exportar as configurações",
    view_votes: "Visualizar votos",
    votes: "Votos",
    featured_post: "Publicação em destaque",
    unfeatured_post: "Publicação não destacada",
    invalid_totp_code: "Código de verificação em dois fatores inválido: De conter 6 dígitos",
    enter_totp_code: "Digite o seu código de verificação em dois fatores",
    enable_totp: "Habilitar autenticação em dois fatores",
    incorrect_totp_code: "Código de verificação em dois fatores incorreto",
    remote_follow_invalid_instance: "{{instance}} não é um domínio válido.",
    remote_follow_local_instance: "Não foi possível localizar a instância local para acompanhar remotamente",
    import_export_section_description: "Importar e exportar suas configurações de conta como JSON",
    export_file_name: "configurações_de_usuário_lemmy",
    export: "Exportar",
    totp_qr: "Código QR de autenticação em dois fatores",
    exporting: "Exportando",
    importing: "Importando",
    import_export_rate_limit_error: "Por favor, espere alguns minutos antes de tentar importar ou exportar as configurações novamente",
    import_error: "Erro ao importar as configurações",
    totp_qr_segue: "ou escaneie esse código QR em um aplicativo de autenticação",
    enable_totp_success: "Autenticação em dois fatores habilitada com sucesso",
    disable_totp_success: "Autenticação em dois fatores desabilitada com sucesso",
    disable_totp: "Desabilitar a autenticação em dois fatores",
    import: "Importar",
    removed_post: "Publicação removida",
    restore_post: "Restaurar publicação",
    restored_post: "Publicação restaurada",
    ban_from_community_with_name: "Banir {{user}} de {{community}}",
    denied: "Negado",
    removed_comment: "Comentário removido",
    restore_comment: "Restaurar comentário",
    restored_comment: "Comentário restaurado",
    undistinguished_comment: "Comentário indistinguível",
    removed_mod: "Moderador Removido",
    removing_mod: "Removendo moderador",
    remove_as_admin_are_you_sure: "Tem certeza que deseja remover {{user}} de {{instance}} da equipe de administração?",
    removing_admin: "Removendo admin",
    removed_admin: "Admin removido",
    appointing_admin: "Designando como admin",
    appointing_mod: "Designar como mod",
    appointed_mod: "Mod designado",
    removing: "Apagando",
    unlocked: "Destrancado",
    locked_post: "Publicação trancada",
    unlocked_post: "Publicação destrancada",
    deleted_post: "Publicação apagada",
    deleted_comment: "Comentário apagado",
    undelete: "Restaurar",
    undeleted_post: "Restaurar publicação",
    undeleted_comment: "Comentário restaurado",
    restoring: "Restaurando",
    permanently_ban: "Banir permanentemente",
    ban_with_name: "Banir {{user}}",
    unban_with_name: "Desbanir {{user}}",
    unbanning: "Desbanindo {{user}}",
    unban_from_community: "Desbanir da comunidade",
    banned_from_community: "Banidos {{user}} de {{community}}",
    unbanned_from_community: "Desbanidos {{user}} de {{community}}",
    banned_from_site: "Banido {{user}}",
    unbanned_from_site: "Desbanido {{user}}",
    purging: "Purgando",
    purge_user_with_name: "Expurgar {{user}}",
    days_until_expiration: "Dias até expirar",
    transferring_community: "Transferindo comunidade",
    transfer_community_are_you_sure: "Tem certeza que deseja transferir {{community}} para {{user}}?",
    transfered_community: "Comunidade transferida",
    creating_report: "Criando denúncia",
    report_post: "Denunciar publicação",
    report_comment: "Denunciar comentário",
    report_message: "Denunciar mensagem",
    totp_link: "Clique aqui para o link de instalação de autenticação em dois fatores",
    confirmation_required: "Confirmação necessária",
    banned_from_community_blurb: "<1>Banido:</1> Você não pode postar, comentar ou votar nesta comunidade. Porém, você ainda pode navegar livremente.",
    private_message_form_user_matrix_blurb: "Este usuário já tem uma conta do Matrix com que pode falar em <1>{{matrix_id}}</1>.",
    community_visibility: "Visibilidade",
    public_blurb: "Esta comunidade pode ser federada a outras instâncias e ser postada/comentada por seus usuários.",
    add: "Adicionar",
    locked_post_comment_placeholder: "Esse conteúdo está trancado, você não pode comentar.",
    unlocking: "Destrancando",
    number_of_local_subscribers_0: "{{formattedCount}} participante local",
    number_of_local_subscribers_1: "{{formattedCount}} participantes locais",
    number_of_local_subscribers_2: "{{formattedCount}} participantes locais",
    listing_mode: "Modo de listagem",
    all_communities: "Todas as comunidades",
    all_users: "Todos os usuários",
    visit_random_community: "Visite uma comunidade aleatória",
    one_hour: "Uma hora",
    six_hours: "Seis horas",
    twelve_hours: "Doze horas",
    one_day: "Um dia",
    one_week: "Uma semana",
    one_month: "Um mês",
    three_months: "Três meses",
    six_months: "Seis meses",
    nine_months: "Nove meses",
    read_terms_and_conditions: "Eu concordo com os termos e condições.",
    read: "Ler",
    show_unread_only: "Mostrar apenas não lidos",
    notifications: "Notificações",
    language_browser_default: "Padrão do navegador",
    theme_instance_default: "Padrão da instância",
    theme_instance_default_compact: "Padrão da instância (compacto)",
    lock_post: "Trancar publicação",
    unlock_post: "Destrancar publicação",
    cross_posted_from_url: "republicado de: {{ap_id}}",
    hide_read_posts: "Esconder publicações lidas",
    card: "Cartão",
    small_card: "Cartão pequeno",
    removing_posts: "Removendo publicações",
    locking_posts: "Trancando publicações",
    locking_comments: "Trancando comentários",
    removing_comments: "Removendo comentários",
    removing_communities: "Removendo comunidades",
    changing_community_visibility: "Mudando a visibilidade da comunidade",
    locking: "Trancando",
    deleted_community: "Comunidade deletada",
    banned_from_community_badge: "Banido da comunidade",
    purge_community_with_name: "Expurgar {{community}}",
    share_post: "Compartilhar publicação",
    one_year: "Um ano",
    seconds: "Segundos",
    days: "Dias",
    minutes: "Minutos",
    hours: "Horas",
    weeks: "Semanas",
    months: "Meses",
    years: "Anos",
    time_interval: "Intervalo de tempo",
    time_unit: "Unidade de tempo",
    lock_comment: "Trancar comentário",
    unlock_comment: "Destrancar comentário",
    show_upvote_percentage: "Mostrar % de votos positivos",
    show_upvotes: "Mostrar votos positivos",
    auto_expand: "Expandir mídia automaticamente",
  },
} as const;